import React, { useEffect } from 'react'
import Layout from '../../components/common/pageLayout'
import CreateForm from '../../components/Inspection/createForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_create_inspection, v3_edit_inspection } from '../../actions/v3/inspection'

const Index = (props) => {
    const location = useLocation();
    const { projectId, projectName, inspectionData } = location.state;

    const onSubmit = (model) => {
        v3_edit_inspection({ ...model, id: inspectionData.ID }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.inspectionProject.url,
                    state: {
                        projectId,
                        projectName
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout title={`Edit Inspection | ${projectName}`}>
            <CreateForm
                onSubmit={onSubmit}
                data={inspectionData}
                projectId={projectId}
                projectName={projectName}
            />
        </Layout>
    )
}

export default Index